// @flow
import React from 'react';
import Select, { Creatable } from 'react-select';
import styles from './Dropdown.scss';

// Usual Props to pass in:
// =======================
// options: object list with `value` `label` (array)
// onChange: function to call upon changing value (func)
// value: selected (string)
// placeholder: (string)
// * clearable: disabled by default (bool)
// * height: 'short' if the height is 32px, for country selector (string)
// * searchable: disabled by default (bool)
// * wrapperClass: class for the wrapper (string)
// * dropdownClass: class for the dropdown (string)

type Props = {
    clearable: boolean,
    dropdownClass: string,
    height: string,
    onChange: Function,
    options: Array<Object>,
    placeholder: string | Object,
    searchable: boolean,
    value: string | number,
    wrapperClass: string,
    creatable: boolean,
}

const Dropdown = (props: Props) => {
    const clearable = props.clearable || false;
    const options = props.options;
    const searchable = props.searchable || false;

    // Leaving this expandable, to add anything in the future
    let classes = `${styles.customStyle}`;
    if (props.height === 'short') {
        classes += ` ${styles.short}`;
    }
    if (props.dropdownClass) {
        classes += ` ${props.dropdownClass}`;
    }
    if (props.creatable) {
        return (
            <div className={`${styles.selectStyleWrapper} ${props.wrapperClass}`}>
                <Creatable
                    {...props}
                    autosize={false}
                    className={classes}
                    clearable={clearable}
                    options={options}
                    searchable={searchable}
                    value={props.value}
                />
            </div>
        );
    }
    return (
        <div className={`${styles.selectStyleWrapper} ${props.wrapperClass}`}>
            <Select
                {...props}
                className={classes}
                clearable={clearable}
                options={options}
                searchable={searchable}
                value={props.value}
            />
        </div>
    );
};


export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/common/dropdown/Dropdown.js